import {FormProvider, useForm} from 'react-hook-form'

import Button from '@mui/material/Button'
import Stack from '@mui/material/Stack'

import Email from '../../shared/Email'
import Form from '../../shared/Form'
import Input from '../../shared/Input'

const Invitation = props => {
  const methods = useForm()
  const {errors} = methods.formState

  return (
    <Stack className='invitation'>
      <FormProvider {...methods}>
      <Form onSubmit={props.handleSubmit}>
        <Email error={!!errors.email} helperText={errors.email?.message} />
        <Input
          error={!!errors.firstName}
          label='First Name'
          name='firstName'
          options={{required: 'First Name is required'}}
          helperText={errors.firstName?.message}
          margin='dense'
        />
        <Input
          error={!!errors.lastName}
          label='Last Name'
          name='lastName'
          options={{required: 'Last Name is required'}}
          helperText={errors.lastName?.message}
          margin='dense'
        />
        <Button
          disabled={props.loading}
          type='submit'
          variant='contained'
          sx={{color: '#F7F7F7'}}>
          Submit
        </Button>
      </Form>
    </FormProvider>
    </Stack>
  )
}

export default Invitation
